import { render, staticRenderFns } from "./SubCategoryList.vue?vue&type=template&id=316487ca&scoped=true&"
import script from "./SubCategoryList.vue?vue&type=script&lang=js&"
export * from "./SubCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./SubCategoryList.vue?vue&type=style&index=0&id=316487ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316487ca",
  null
  
)

export default component.exports